// Lightweight i18n. Use t("key") via useLang().
export const LANGS = [
  { code: "ca", label: "CA" },
  { code: "es", label: "ES" },
  { code: "en", label: "EN" },
];

export const STRINGS = {
  ca: {
    brand_tagline: "Experiències culturals a Catalunya",
    enter: "Entrar",
    register: "Registrar-se",
    login: "Iniciar sessió",
    email: "Correu electrònic",
    password: "Contrasenya",
    name: "Nom",
    welcome_kicker: "Temporada I",
    welcome_title: "De la polis a la fàbrica",
    welcome_sub:
      "Cinc jornades per recórrer el patrimoni amagat de Catalunya, de la mà d'historiadors, botànics i cuiners.",
    good_morning: "Bon dia",
    chapters_count: "cinc capítols",
    cta_explore: "Descobrir la temporada",
    cta_login: "Ja tinc compte",
    home_kicker: "Temporada en curs",
    home_title: "Pròximes experiències",
    calendar: "Calendari",
    trips: "Viatges",
    profile: "Perfil",
    home: "Inici",
    book_now: "Reservar",
    duration: "Durada",
    hours: "h",
    location: "Lloc",
    season: "Temporada",
    capacity: "Places",
    from_price: "Des de",
    per_person: "/persona",
    itinerary: "Itinerari",
    gastronomy: "Gastronomia",
    guests: "Participants",
    select_date: "Selecciona data",
    select_guests: "Selecciona participants",
    summary: "Resum",
    total: "Total",
    proceed_to_payment: "Pagar",
    card_name: "Nom al titular",
    card_number: "Número de targeta",
    card_expiry: "Caducitat",
    card_cvc: "CVC",
    pay_now: "Confirmar pagament",
    mock_notice:
      "Pagament simulat — ARISTEIA prototip. Cap càrrec real.",
    confirmed: "Reserva confirmada",
    confirmed_sub:
      "T'hem enviat un correu amb el teu pas i els detalls de la jornada.",
    view_trips: "Veure els meus viatges",
    my_trips: "Els meus viatges",
    no_trips: "Encara no tens experiències reservades.",
    explore: "Explorar temporada",
    notifications: "Notificacions",
    n_email: "Confirmacions per correu",
    n_push: "Recordatoris de jornada",
    n_new: "Noves experiències",
    n_offers: "Ofertes d'última hora",
    language: "Idioma",
    logout: "Tancar sessió",
    member_since: "Membre des de",
    chapter: "Capítol",
    season_label: "Temporada",
    edit_prefs: "Editar preferències",
    save: "Desar",
    saved: "Desat",
    payment_secure:
      "Transacció encriptada · Stripe / RedSys (simulat per al prototip)",
    invoice_ref: "Factura Holded",
    confirmation_email_to: "Correu enviat a",
    upcoming: "Properes",
    completed: "Completades",
    privacy: "Privacitat",
    cookies: "Galetes",
    legal_notice: "Avís legal",
    terms: "Termes i condicions",
    sitemap: "Mapa del lloc",
    legal: "Legal",
    sold_out: "Exhaurit",
    sold_out_note: "Les places de la temporada estan exhaurides. Uneix-te a la llista d'espera per a properes edicions.",
  },
  es: {
    brand_tagline: "Experiencias culturales en Catalunya",
    enter: "Entrar",
    register: "Registrarse",
    login: "Iniciar sesión",
    email: "Correo electrónico",
    password: "Contraseña",
    name: "Nombre",
    welcome_kicker: "Temporada I",
    welcome_title: "De la polis a la fábrica",
    welcome_sub:
      "Cinco jornadas para recorrer el patrimonio oculto de Catalunya, de la mano de historiadores, botánicos y cocineros.",
    good_morning: "Buenos días",
    chapters_count: "cinco capítulos",
    cta_explore: "Descubrir la temporada",
    cta_login: "Ya tengo cuenta",
    home_kicker: "Temporada en curso",
    home_title: "Próximas experiencias",
    calendar: "Calendario",
    trips: "Viajes",
    profile: "Perfil",
    home: "Inicio",
    book_now: "Reservar",
    duration: "Duración",
    hours: "h",
    location: "Lugar",
    season: "Temporada",
    capacity: "Plazas",
    from_price: "Desde",
    per_person: "/persona",
    itinerary: "Itinerario",
    gastronomy: "Gastronomía",
    guests: "Comensales",
    select_date: "Selecciona fecha",
    select_guests: "Selecciona participantes",
    summary: "Resumen",
    total: "Total",
    proceed_to_payment: "Pagar",
    card_name: "Nombre del titular",
    card_number: "Número de tarjeta",
    card_expiry: "Caducidad",
    card_cvc: "CVC",
    pay_now: "Confirmar pago",
    mock_notice:
      "Pago simulado — prototipo ARISTEIA. Ningún cargo real.",
    confirmed: "Reserva confirmada",
    confirmed_sub:
      "Te hemos enviado un correo con tu pase y los detalles de la jornada.",
    view_trips: "Ver mis viajes",
    my_trips: "Mis viajes",
    no_trips: "Aún no tienes experiencias reservadas.",
    explore: "Explorar temporada",
    notifications: "Notificaciones",
    n_email: "Confirmaciones por correo",
    n_push: "Recordatorios de jornada",
    n_new: "Nuevas experiencias",
    n_offers: "Ofertas de última hora",
    language: "Idioma",
    logout: "Cerrar sesión",
    member_since: "Miembro desde",
    chapter: "Capítulo",
    season_label: "Temporada",
    edit_prefs: "Editar preferencias",
    save: "Guardar",
    saved: "Guardado",
    payment_secure:
      "Transacción cifrada · Stripe / RedSys (simulado para el prototipo)",
    invoice_ref: "Factura Holded",
    confirmation_email_to: "Correo enviado a",
    upcoming: "Próximas",
    completed: "Completadas",
    privacy: "Privacidad",
    cookies: "Cookies",
    legal_notice: "Aviso legal",
    terms: "Términos y condiciones",
    sitemap: "Mapa del sitio",
    legal: "Legal",
    sold_out: "Agotado",
    sold_out_note: "Las plazas de la temporada están agotadas. Únete a la lista de espera para próximas ediciones.",
  },
  en: {
    brand_tagline: "Cultural experiences in Catalonia",
    enter: "Enter",
    register: "Register",
    login: "Sign in",
    email: "Email",
    password: "Password",
    name: "Name",
    welcome_kicker: "Season I",
    welcome_title: "From the polis to the factory",
    welcome_sub:
      "Five days to wander the hidden heritage of Catalonia, guided by historians, botanists and chefs.",
    good_morning: "Good morning",
    chapters_count: "five chapters",
    cta_explore: "Discover the season",
    cta_login: "I already have an account",
    home_kicker: "Current season",
    home_title: "Upcoming experiences",
    calendar: "Calendar",
    trips: "Trips",
    profile: "Profile",
    home: "Home",
    book_now: "Book",
    duration: "Duration",
    hours: "h",
    location: "Location",
    season: "Season",
    capacity: "Seats",
    from_price: "From",
    per_person: "/person",
    itinerary: "Itinerary",
    gastronomy: "Gastronomy",
    guests: "Participants",
    select_date: "Select a date",
    select_guests: "Select participants",
    summary: "Summary",
    total: "Total",
    proceed_to_payment: "Pay",
    card_name: "Cardholder name",
    card_number: "Card number",
    card_expiry: "Expiry",
    card_cvc: "CVC",
    pay_now: "Confirm payment",
    mock_notice:
      "Simulated payment — ARISTEIA prototype. No real charge.",
    confirmed: "Booking confirmed",
    confirmed_sub:
      "We've sent you an email with your pass and the details of the day.",
    view_trips: "View my trips",
    my_trips: "My trips",
    no_trips: "You don't have any experiences booked yet.",
    explore: "Explore the season",
    notifications: "Notifications",
    n_email: "Email confirmations",
    n_push: "Day reminders",
    n_new: "New experiences",
    n_offers: "Last-minute offers",
    language: "Language",
    logout: "Sign out",
    member_since: "Member since",
    chapter: "Chapter",
    season_label: "Season",
    edit_prefs: "Edit preferences",
    save: "Save",
    saved: "Saved",
    payment_secure:
      "Encrypted transaction · Stripe / RedSys (simulated for the prototype)",
    invoice_ref: "Holded invoice",
    confirmation_email_to: "Email sent to",
    upcoming: "Upcoming",
    completed: "Completed",
    privacy: "Privacy",
    cookies: "Cookies",
    legal_notice: "Legal notice",
    terms: "Terms & conditions",
    sitemap: "Sitemap",
    legal: "Legal",
    sold_out: "Sold out",
    sold_out_note: "This season is sold out. Join the waitlist for future editions.",
  },
};

export function pick(obj, lang) {
  if (!obj) return "";
  if (typeof obj === "string") return obj;
  return obj[lang] || obj.es || obj.en || obj.ca || Object.values(obj)[0] || "";
}
